// extracted by mini-css-extract-plugin
module.exports = {"main":"Spinner_main__2Hc3J","spin":"Spinner_spin__3GFA6"};